// extracted by mini-css-extract-plugin
export default {"Btn":"BtnScrollToTop_Btn__1VbpD"};